import { render, staticRenderFns } from "./ReportLayout.vue?vue&type=template&id=ecbba65e&scoped=true"
import script from "./ReportLayout.vue?vue&type=script&lang=ts"
export * from "./ReportLayout.vue?vue&type=script&lang=ts"
import style0 from "./ReportLayout.vue?vue&type=style&index=0&id=ecbba65e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecbba65e",
  null
  
)

export default component.exports